
import { computed } from 'vue';
import store from '@/store/index'
import router from '@/router';

export default {
    name: 'ModalOnboarding',
    setup() {
        const showModal = computed({
            get: () => store.getters['onboarding/showModal'],
            set: (val: boolean) => {
                if (!val) store.dispatch('onboarding/closeModal');
            }
        });

        const handleConfirm = () => {
            store.dispatch('onboarding/closeModal');
            router.push('/radian');
        };

        return { showModal, handleConfirm };
    }
}
